import { render, staticRenderFns } from "./BankPayments.vue?vue&type=template&id=588dd860"
import script from "./BankPayments.vue?vue&type=script&lang=js"
export * from "./BankPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports